import { Separator } from '../../../../../primitives/separator';
import { EditorPlain } from '../../../../editor/components/editor-plain';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Typography } from '../controls/typography';

import type { HeadingEditorContentProps } from './types';

export type { HeadingEditorStyleUpdates } from './types';

export function HeadingEditorContent({
  alignment,
  backgroundColor,
  fontFamily,
  fontWeight,
  level,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  text,
  textColor,
  onLevelChange,
  onStyleChange,
  onTextChange,
}: HeadingEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Encabezado
          </LabelWithoutRef>
          <EditorPlain
            counter={{ enable: true }}
            ext={{ mention: { items: ['variable'] } }}
            id="content-heading"
            type="input"
            value={text}
            onChange={(value) => onTextChange(value)}
          />
        </div>
      </div>

      <Separator />

      <Typography
        backgroundColor={backgroundColor}
        fontFamily={fontFamily}
        fontLevel={level}
        fontWeight={fontWeight}
        isBackgroundColorVisible
        isFontFamilyVisible
        isFontLevelVisible
        isFontWeightVisible
        isTextColorVisible
        textColor={textColor}
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
        onFontFamilyChange={(fontFamily) => onStyleChange({ fontFamily })}
        onFontLevelChange={(fontLevel) => onLevelChange(fontLevel)}
        onFontWeightChange={(fontWeight) => onStyleChange({ fontWeight })}
        onTextColorChange={(color) => onStyleChange({ color })}
      />

      <Separator />

      <Alignment
        isHorizontalAlignmentVisible
        horizontalAlignment={alignment}
        onHorizontalAlignmentChange={(textAlign) => onStyleChange({ textAlign })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
